import { Component, OnInit, ChangeDetectorRef, HostListener, Input } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api/public_api';
import { TicketsService } from 'src/app/services';
import { ActivatedRoute,Router } from '@angular/router';
import { DatePipe } from '@angular/common'
import {FacilityService} from 'src/app/services'
import { UserFacility, UserLocationFacility } from 'src/app/models';
@Component({
  selector: 'bart-dash-ticket',
  templateUrl: './dash-ticket.component.html',
  styleUrls: ['./dash-ticket.component.scss']
})
export class DashTicketComponent implements OnInit {
  @Input() userName: string;
  @Input() userId: number;
  @Input() bartRoleCode: string;
  @Input() boxHeight: number;
  public userFacilityIdList:string

  maxRecords = 50;
  returnTotalCount = 0;
  returnAllRecords = 1;
  queryTimeout = 60;
  nextTicketId = "NULL";

  public dashTicketList: any[];
  public dbDashTickets: any[];
  public cols: any[];
  rows: number;
  public totalRecords:number=0;
  loading = false;
  isPaginatorVisible:boolean=false;
  showNoRecordMessage:boolean=false;
  constructor
  (
        private changeDetectorRef: ChangeDetectorRef, 
        private activatedRoute: ActivatedRoute,
        private ticketService: TicketsService,
        private router: Router ,
        public datepipe: DatePipe,
        private facilityService:FacilityService
  ) {}
  ngOnInit() {
    this.rows = this.maxRecords;
    this.totalRecords=0;
    this.dashTicketList=[];
    this.loading = true;
    this.facilityService.getUserLocationFacilities(this.userName,(facilities:UserLocationFacility[])=>
    {
      if(facilities)
      {
        let userFacilityList:UserLocationFacility[]=facilities;
        this.userFacilityIdList=userFacilityList.map(x => x.FacilityMasterID).join(", ");
        this.getDashboardTickets();
      }
    });
  }
  public getDashboardTickets() {
    var d = new Date();
    let myTicketsStartDate 	= this.datepipe.transform((d.setDate(d.getDate() - 90)),'MM/dd/yyyy');
    let myTicketsEndDate 	= this.datepipe.transform(new Date(), 'MM/dd/yyyy');
   let DASHTICKETS={
      ticketstatusid:2,
      facilityMasterIdList: this.userFacilityIdList,
      ticketSearchStartDate:myTicketsStartDate,
      ticketSearchEndDate:myTicketsEndDate,
      userId:this.userId,
      nextTicketId:null,
      returnTotalCount:0,
      returnAllRecords:1,
      bartRoleCode:this.bartRoleCode,
      maxRecords:50,
      orderBy:"ticketId desc",
      searchTerm:null
  }

if (DASHTICKETS != null) {
      this.loading = true;
      this.ticketService.dashTickets(JSON.stringify( {DASHTICKETS}))
      .subscribe((resp: Array<any>) => {
        try
        {
          this.dbDashTickets = resp;
          this.totalRecords = this.dbDashTickets.length;
          this.dashTicketList=this.dbDashTickets;//this.dbDashTickets.slice(0, this.rows);
          this.loading = false;
          this.isPaginatorVisible=false
          this.isPaginatorVisible=true;
          if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
          }
        }
        catch(error)
        {
          this.loading = false;
          if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
          }
          console.log(error)
        }
        }, 
        (error) => 
        {
          this.dbDashTickets = [];
          this.loading=false
          if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
          }
          console.log(error)
          // handle error here
        }
      );
    }
  }
  public loadDataOnScroll(event: LazyLoadEvent) {
    if(this.dbDashTickets)
    {
        this.loading = true;
        setTimeout(() => {
          //this.dashTicketList=[]
          this.dashTicketList = this.dbDashTickets? this.dbDashTickets.slice(event.first, (event.first + event.rows)) : [];
          this.loading = false;
          if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
          }
      }, 1000);
    }
  }
  public OpenTicketSummmary(ticketId:number)
  {
    this.router.navigate(['/tickets', ticketId]);
  }
}

